// Imports For Images
import mail from "./mail.png";
import logo from "./logo.png";
import add from "./add.png";
import phone from "./phone.png";
import star from "./star.png";
import tick from "./tick.png";
import facebook from "./facebook.png";
import instagram from "./instagram.png";
import twitter from "./twitter.png";
import linkedin from "./linkedin.png";
import pinterest from "./pinterest.png";
import whatsapp from "./whatsapp.png";
import about from "./about-img.png";
import clientOne from "./client-1.png";
import clientTwo from "./client-2.jfif";
import clientThree from "./client-3.png";
import clientFour from "./client-4.png";
import clientFive from "./client-5.png";
import clientSix from "./client-6.jpg";
import home from "./home.png";
import arrow from "./arrow.png";
import s1 from "./slide-1.png";
import s2 from "./slide-2.png";
import s3 from "./slide-3.png";
import s4 from "./slide-4.png";
import s5 from "./slide-5.png";
import aboutH from "./about-h.png"
import aboutII from "./aboutLat.png"

// Exports For Images
export const mailIcon = mail;
export const logoIcon = logo;
export const addIcon = add;
export const homeIcon = home;
export const phoneIcon = phone;
export const starIcon = star;
export const tickIcon = tick;
export const facebookIcon = facebook;
export const instagramIcon = instagram;
export const twitterIcon = twitter;
export const linkedIcon = linkedin;
export const PinterestIcon = pinterest;
export const whatsappIcon = whatsapp;
export const aboutImage = about;
export const clientFirst = clientOne;
export const clientSecond = clientTwo;
export const clientThird = clientThree;
export const clientFourth = clientFour;
export const clientFifth = clientFive;
export const clientSixth = clientSix;
export const arrowIcon = arrow;
export const slideOne = s1;
export const slideTwo = s2;
export const slideThree = s3;
export const slideOFour = s4;
export const slideFive = s5;
export const AboutImg = aboutH;
export const AboutImgII = aboutII;

